import { Card, CardContent, Link, Typography } from '@mui/material';
import { Page, Spacer } from '../../components';
import { useObservable } from '@aesop-fables/scrinium';
import { useService } from '@aesop-fables/containr-react';
import {
  AdminTierTypeEnum,
  DrillDownWizard,
  drillDownWizardKey,
  drillDownTierToAdminTier,
} from '../../services/drillDown';
import { capitalize } from 'lodash';
import AboutYourGroupCard from '../group/AboutYourGroupCard';
import TeamMetricsCard from '../team/TeamMetricsCard';
import GroupMetricsCard from '../group/GroupMetricsCard';
import AboutYourTeamCard from '../team/AboutYourTeamCard';
import { type JSX } from 'react';

const AdminInfo = () => {
  const drillDownWizard = useService<DrillDownWizard>(drillDownWizardKey);
  const tier = useObservable(drillDownWizard.tier$);

  const adminTier = tier ? drillDownTierToAdminTier(tier) : undefined;

  let aboutCard: JSX.Element | undefined;
  let metricsCard: JSX.Element | undefined;

  switch (adminTier) {
    case AdminTierTypeEnum.Group:
      aboutCard = <AboutYourGroupCard />;
      metricsCard = <GroupMetricsCard />;
      break;
    case AdminTierTypeEnum.Team:
      aboutCard = <AboutYourTeamCard />;
      metricsCard = <TeamMetricsCard />;
      break;
  }

  if (!adminTier || !aboutCard || !metricsCard) {
    return null;
  }

  return (
    <Page title={`${capitalize(adminTier)} info`}>
      <Spacer height='xs' />
      {aboutCard}
      <Spacer height='xs' />
      {metricsCard}
    </Page>
  );
};

interface RoleInfoCardProps extends React.PropsWithChildren {
  title?: string;
  editable: boolean;
  setDrawerOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  onEdit?: () => void;
}

export const RoleInfoCard: React.FC<RoleInfoCardProps> = props => {
  const { title, editable, setDrawerOpen, onEdit } = props;

  const onEditClick = () => {
    if (onEdit) {
      onEdit();
      return;
    }
    if (setDrawerOpen) {
      setDrawerOpen(true);
      return;
    }
  };

  return (
    <>
      {title && (
        <>
          <Typography variant='subtitle1' color='secondary.main'>
            {title}
          </Typography>
          <Spacer height='xs' />
        </>
      )}
      <Card variant='ghost' color='primary'>
        <CardContent
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
          className={editable ? `profileCard` : `pad30`}>
          {editable ? (
            <>
              <Link onClick={onEditClick} style={{ alignSelf: 'flex-end' }} variant='body2'>
                Edit
              </Link>
              <Spacer height='xxs' />
            </>
          ) : null}
          {props.children}
        </CardContent>
      </Card>
    </>
  );
};

export default AdminInfo;
